export function stripHtmlToPlainText(html: string | null | undefined): string {
  if (!html) return '';
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function richHtmlIsEmpty(html: string | null | undefined): boolean {
  return stripHtmlToPlainText(html).length === 0;
}
